module.exports = __webpack_public_path__ + "img/compresor-3.3d750daa.png";